import React, { useState, useEffect } from 'react'
import ball1 from './ball1.svg'
import ball2 from './ball2.svg'
import ball3 from './ball3.svg'
import profilepic from './../../assets/profilepic.jpg'
import './hero.css'

const Hero = ({ ref }) => {

    const [dynamicScroll, setDynamicScroll] = useState(0);

    const handleScroll = () => {
        const position = window.pageYOffset;
        setDynamicScroll(position / 140);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (<>
        <div className="hero-hero">
            <h1 className="hello text-gradient" style={{ transform: `translateY(${dynamicScroll * -2}rem)` }}>
                Hello, I'm Pulkit,
            </h1>
            <h1 className="title" style={{ transform: `translateY(${dynamicScroll * -1.4}rem)` }}>
                a frontend developer
            </h1>
            <p className="about" style={{ transform: `translateY(${dynamicScroll * -0.5}rem)` }}>
                An open source enthusiast, who has been developing and learning for more than 4 years, with focus on collaboration, communcation and passion.
            </p>
            <div style={{ transform: `translateY(${dynamicScroll * 0}rem)` }} onClick={() => alert("CV not uploaded yet")}>
                <button className="resume">
                    Download CV
                </button>
            </div>

            <div className="balls">
                <img src={ball1} className='ball1' style={{ transform: `translateY(${dynamicScroll * -1}rem)` }} />
                <img src={ball2} className='ball2' style={{ transform: `translateY(${dynamicScroll * -4}rem)` }} />
                <div className="ball3">

                    <img src={ball3} className='pp-bg' style={{ transform: `translateY(${dynamicScroll * -6}rem)` }} />
                    <img src={profilepic} className='pp' style={{ transform: `translateY(${dynamicScroll * -6}rem)` }} />
                </div>
            </div>

        </div>


    </>
    )
}

export default Hero